import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
let router = new Router({
  routes: [
    {
      path: "/",
      component: (resolve) => require(["@/views/home/index"], resolve),
      meta: {
        title: "联动Pay",
      },
    },
    {
      path: "/registeredAgent",
      component: (resolve) =>
        require(["@/views/registeredAgent/index"], resolve),
      meta: {
        title: "联动pay展业版",
        keepalive: true,
      },
    },
    {
      path: "/agentDownload",
      component: (resolve) =>
        require(["@/views/registeredAgent/agentDownload"], resolve),
      meta: {
        title: "注册成功",
      },
    },
    {
      path: "/protocol",
      component: (resolve) =>
        require(["@/views/registeredAgent/protocol"], resolve),
      meta: {
        title: "",
      },
    },
    {
      path: "/copdownload",
      component: (resolve) => require(["@/views/copdownload/index"], resolve),
      meta: {
        title: "联动pay展业版",
      },
    },
    {
      path: "/merdownload",
      component: (resolve) => require(["@/views/merdownload/index"], resolve),
      meta: {
        title: "联动pay",
      },
    },
    {
      path: "/privacy",
      component: (resolve) => require(["@/views/privacy/index"], resolve),
      meta: {
        title: "展业隐私政策协议",
      },
    },
    {
      path: "/agreement",
      component: (resolve) => require(["@/views/agreement/index"], resolve),
      meta: {
        title: "展业用户协议",
      },
    },
    {
      path: "/merPrivacy",
      component: (resolve) => require(["@/views/merPrivacy/index"], resolve),
      meta: {
        title: "商户隐私政策协议",
      },
    },
    {
      path: "/facePrivacy",
      component: (resolve) => require(["@/views/face/index"], resolve),
      meta: {
        title: "人脸处理信息协议",
      },
    },
    {
      path: "/merAgreement",
      component: (resolve) => require(["@/views/merAgreement/index"], resolve),
      meta: {
        title: "商户用户协议",
      },
    },
    //未绑定的商户
    {
      path: "/bind",
      component: (resolve) => require(["@/views/merchant/index"], resolve),
      meta: {
        title: "商户绑定",
      },
    },
    //已绑定 需要解绑等的页面
    {
      path: "/unbind",
      component: (resolve) => require(["@/views/merchant/Unbinding"], resolve),
      meta: {
        title: "商户绑定",
      },
    },

    //解绑成功
    {
      path: "/success",
      component: (resolve) => require(["@/views/merchant/success"], resolve),
      meta: {
        title: "商户解绑",
      },
    },

    //微信认证
    {
      path: "/wxcode",
      component: (resolve) => require(["@/views/merchant/wxcode"], resolve),
      meta: {
        title: "开户意愿确认",
      },
    },

    //支付宝认证
    {
      path: "/Alipaycode",
      component: (resolve) => require(["@/views/merchant/Alipaycode"], resolve),
      meta: {
        title: "开户意愿确认",
      },
    },

    //活體認證
    {
      path: "/faceAuth",
      component: (resolve) => require(["@/views/faceAuth/index"], resolve),
      meta: {
        title: "人脸认证",
      },
    },
    //意願核身
    {
      path: "/faceIDAuth",
      component: (resolve) => require(["@/views/faceIDAuth/index"], resolve),
      meta: {
        title: "意愿核身",
      },
    },
    //认证
    {
      path: "/auth",
      component: (resolve) => require(["@/views/auth/index"], resolve),
      meta: {
        title: "活体认证",
      },
    },
    //认证
    {
      path: "/auth/media",
      component: (resolve) => require(["@/views/auth/media"], resolve),
      meta: {
        title: "活体认证",
      },
    },
    //认证成功
    {
      path: "/auth/success",
      component: (resolve) => require(["@/views/auth/success"], resolve),
      meta: {
        title: "温馨提示",
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 };
  },
});

export default router;
